import { ScenarioActions } from '~/actions/'

/*
  updaters : [
      path : "a/b",
      attributeType : 'number'
      timeline : [
        { 
          id : <uuid>,
          time : <sec from start>,
          value : <value>,
          interpolator : { type : 'linear'} 
        },
        { 
          id : <uuid>,
          time : <sec from start>,
          value : <value>,
          interpolator : { type : 'linear'} 
        }
      ]
    ]
*/

const initialState = {
  error : null,
  scenario : null,
  blueprint : null
}

function scenario( state = initialState, action ) {
  switch ( action.type ) {

    case ScenarioActions.SET_SCENARIO: {
      return { 
        error : null,
        scenario : action.scenario,
        blueprint : state.blueprint || action.blueprint
      }
    }

    case ScenarioActions.GET_SCENARIO: {
      return { 
        error : null,
        scenario : action.scenario,
        blueprint : action.blueprint
      }
    }
    default:
      return state
  }
}

module.exports = scenario
